import { BubbleMetadata } from '@/components/public/Visualisations/BubblesV2/Metadata'
import { Shapes } from '@/components/public/Visualisations/types'
import { PopupDetails } from '@/types'
import Konva from 'konva'

const SELECTED_STROKE_COLOR = 'black'
const HIGHLIGHTED_STROKE_COLOR = 'black'

export class BubbleCircleV2
  extends Konva.Circle
  implements Shapes.Shape, Shapes.Selectable, Shapes.Highlightable, Shapes.HasPopup
{
  static readonly shapeName = 'bubble'
  private _metadata: BubbleMetadata
  private _isHighlighted: boolean = false
  private _isSelected: boolean = false
  className = BubbleCircleV2.shapeName
  capabilities: Shapes.Capability[] = [
    Shapes.Capability.Selectable,
    Shapes.Capability.Highlightable,
    Shapes.Capability.Popup,
    Shapes.Capability.Fadable,
  ]

  constructor(metadata: BubbleMetadata) {
    super()

    this._metadata = metadata
  }

  get key() {
    return this.path.toString()
  }

  get center() {
    const position = this.position()
    const group = this.getParent()
    if (group) {
      position.x += group.x()
      position.y += group.y()
    }

    return position
  }

  get left() {
    return this.center.x - this.radius() - this._metadata.haloMetadata.totalWidth
  }

  get top() {
    return this.center.y - this.radius() - this._metadata.haloMetadata.totalWidth
  }

  get isHighlighted() {
    return this._isHighlighted
  }

  set isHighlighted(value: boolean) {
    this._isHighlighted = value
    this.stroke(this._stroke)
  }

  get isSelected() {
    return this._isSelected
  }

  set isSelected(value: boolean) {
    this._isSelected = value
    this.stroke(this._stroke)
  }

  get popupDetails(): PopupDetails {
    return {
      node: this._metadata.visNode,
      leftBuffer: 10,
    }
  }

  get path() {
    return this._metadata.path
  }

  refresh() {
    const strokeWidth = this._metadata.borderWidth
    const radius = this._metadata.radius - strokeWidth / 2

    this.radius(radius)
    this.strokeWidth(strokeWidth)
    this.stroke(this._stroke)
    this.fill(this._metadata.fill)
  }

  get _stroke() {
    if (this.isSelected) {
      return SELECTED_STROKE_COLOR
    }
    if (this.isHighlighted) {
      return HIGHLIGHTED_STROKE_COLOR
    }
    return this._metadata.borderColour
  }
}
